module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qskel5-2260c2f88efb5830a81ca7f004cae992.jpg";